import React from 'react';

const StatSeparator = () => (
  <i className='fas fa-circle text-neutral-300 align-middle mt-0 mx-1.5 mb-px text-[4px]' />
);

export interface AssetStatsProps {
  children: React.ReactNode[];
}

export default function AssetStats({ children }: AssetStatsProps) {
  function* render(children: AssetStatsProps['children']) {
    for (let i = 0; i < children.length; i++) {
      const child = children[i];

      yield child;

      if (i !== children.length - 1) {
        yield <StatSeparator key={`separator_${i}`} />;
      }
    }
  }

  return <>{Array.from(render(children.filter((child) => !!child)))}</>;
}
